import { getFullDate } from 'Utils/time';
import { BaseReactiveClass } from './BaseReactiveClass';

export class BasePostClass extends BaseReactiveClass {
  set author(authorData) {
    const AuthorClass = this._getAuthorClass();
    this.$set('_author', new AuthorClass(authorData));
  }

  set category(categoryData) {
    const CategoryClass = this._getCategoryClass();
    this.$set('_category', new CategoryClass(categoryData));
  }

  // eslint-disable-next-line camelcase
  get featured_post() {
    return this._featured_post;
  }

  // eslint-disable-next-line camelcase
  set featured_post(data) {
    const PostClass = this._getPostClass();
    this.$set('_featured_post', new PostClass(data));
  }

  get hasFeaturedPost() {
    return Boolean(this.featured_post?.slug);
  }

  get featuredPost() {
    return (this.hasFeaturedPost ? this.featured_post : this.children?.[0]) || {};
  }

  /* sub classes */

  get author() {
    return this._author;
  }

  set children(childrenRaw) {
    const PostClass = this._getPostClass();
    const children = childrenRaw?.map((itemData) => {
      if (itemData instanceof PostClass) return itemData;
      return new PostClass(itemData);
    }) || [];
    this.$set('_children', children);
  }

  get category() {
    return this._category;
  }

  set tags(tagsRaw) {
    const TagClass = this._getTagClass();
    const tags = tagsRaw?.map(itemData => new TagClass(itemData));
    this.$set('_tags', tags);
  }

  // eslint-disable-next-line camelcase
  set you_may_also_like(postListRaw) {
    const PostClass = this._getPostClass();
    const list = postListRaw?.map(itemData => new PostClass(itemData)) || [];
    this.$set('youMightAlsoLikePosts', list);
  }

  get childrenFiltered() {
    return this.children.filter(post => post.slug !== this.featuredPost?.slug);
  }

  get children() {
    return this._children;
  }

  _getAuthorClass() {
    return BasePostClass;
  }

  get tags() {
    return this._tags;
  }

  _getPostClass() {
    return BasePostClass;
  }

  _getCategoryClass() {
    return BasePostClass;
  }

  /* * * * * * * */

  _getTagClass() {
    return BasePostClass;
  }

  get childrenLength() {
    return this.children.length || 0;
  }

  get childrenCount() {
    return this.count || 0;
  }

  get hasMoreChildren() {
    return Boolean(this.childrenLength < this.childrenCount);
  }

  get imageUrl() {
    return this.thumbnail?.large?.url || '';
  }

  get imagePlaceholderUrl() {
    return this.thumbnail?.placeholder?.url || '';
  }

  get imagePlaceholderAlt() {
    return this.thumbnail?.placeholder?.alt || this.name || '';
  }

  get imagePlaceholderTitle() {
    return this.thumbnail?.placeholder?.name || this.name || '';
  }

  get authorFullName() {
    return this.author.fullName;
  }

  get publicationDateFull() {
    return getFullDate(this.publication_date);
  }

  get categoryName() {
    return this.category?.name || this.parent?.name || '';
  }

  get hasCategory() {
    return Boolean(this.category?.name);
  }

  addChildren(newChildrenList) {
    this.children = this.children.concat(newChildrenList);
  }
}
